import { type Common } from './common.js';
import { type PaginatedQueryOptions } from './models/pagination/PaginatedQueryOptions.type.js';
import { type PaginationResponse } from './models/pagination/PaginationResponse.type.js';
import {
  type PayoutAdjustment,
  type PayoutAdjustmentArgs,
  type PayoutAdjustmentRemoveResponse,
} from './models/payoutAdjustment.js';

export class API {
  common: Common;
  baseEndpoint = '/payouts/adjustments';

  constructor(common: Common) {
    this.common = common;
  }

  async findOneById(id: string): Promise<PayoutAdjustment> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }

  async upsert(adjustment: Partial<PayoutAdjustment>[]): Promise<PayoutAdjustment[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}`);
    return await this.common.putJSON(url, adjustment);
  }

  async remove(id: string): Promise<PayoutAdjustmentRemoveResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.deleteJSON(url);
  }

  async findAll(args: PayoutAdjustmentArgs): Promise<PayoutAdjustment[]> {
    const url = this.common.constructPath(this.baseEndpoint, args);
    const { payoutAdjustments } = await this.common.getJSON(url);
    return payoutAdjustments;
  }

  async findAllPaginated(
    args: PaginatedQueryOptions<PayoutAdjustmentArgs>
  ): Promise<PaginationResponse<PayoutAdjustment>> {
    const url = this.common.constructPath(this.baseEndpoint, args);
    return await this.common.getJSON(url);
  }
}
